export default __webpack_public_path__ + "static/crediflow-rgb-220ccc1502713f6cbf666a9d3875ce91.svg";